import { GutXAxisOrgan, OrganLookupCode } from '@repo/types';
import { GutXAxisOrganBadge, Typography } from '@repo/ui';
import styles from './OrganSelectorRow.module.css';

type OrganSelectorRowProps = {
  organ: GutXAxisOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
  /** Every code the map draws, so the badge crops the same gut. */
  drawnCodes?: ReadonlySet<OrganLookupCode>;
};

/** One organ as badge and name, shared by the selector's trigger and its list. */
export default function OrganSelectorRow({
  organ,
  age,
  pregnant,
  sex,
  drawnCodes,
}: OrganSelectorRowProps) {
  return (
    <span className={styles.row}>
      <GutXAxisOrganBadge
        organ={organ}
        age={age}
        pregnant={pregnant}
        sex={sex}
        drawnCodes={drawnCodes}
      />
      <Typography variant='body-s'>{organ.display_name}</Typography>
    </span>
  );
}
